import { useTranslation } from 'react-i18next';
import { usePatientInfo } from 'infrastructure/hooks/patient/use-patient-info';
import {
  hasStatusForDisableCcmModule,
  hasStatusForDisableRpmModule,
} from 'infrastructure/functions/status-check';
import { Flex, Typography } from 'antd';

import s from './styles.module.scss';
import InfoBlock from './info-block';

import type { CcmStatuses, RpmStatuses } from 'infrastructure/enums';
import type { FC } from 'react';

const { Text } = Typography;

const checkProgramType = (rpmStatus?: RpmStatuses, ccmStatus?: CcmStatuses) => {
  let rpm = false;
  let ccm = false;

  if (rpmStatus) rpm = !hasStatusForDisableRpmModule(rpmStatus);
  if (ccmStatus) ccm = !hasStatusForDisableCcmModule(ccmStatus);

  const statusMap = {
    RPM: rpm,
    CCM: ccm,
  };

  return Object.entries(statusMap)
    .filter(([, value]) => value)
    .map(([key]) => key)
    .join('/');
};

interface PatientInfoProps {
  patientGuid: string;
}

const PatientInfo: FC<PatientInfoProps> = ({ patientGuid }) => {
  const { patientInfo, loading: infoLoading } = usePatientInfo({ patientGuid });
  const { t } = useTranslation();

  const monthlyInteractionStatus = patientInfo?.interactionStatus
    ? t('controls.yes')
    : t('controls.no');
  const followUpStatus = patientInfo?.ccmInteractionStatus
    ? t('controls.yes')
    : t('controls.no');
  const programType = checkProgramType(
    patientInfo?.status,
    patientInfo?.ccmStatus,
  );

  return (
    <div className={s.time}>
      <Flex align="center" justify="space-between" className={s['time-header']}>
        <Text className={s['time-title']}>{t('labels.patientInfo')}</Text>
      </Flex>

      <Flex vertical data-info className={s['time-content']} gap={6}>
        <InfoBlock
          label={t('labels.programType')}
          value={programType}
          isProgramDisplay
          isLoading={infoLoading}
        />
        <InfoBlock
          label={t('links.monthlyInteractionStatus')}
          value={monthlyInteractionStatus}
          isLoading={infoLoading}
        />
        <InfoBlock
          label={t('labels.followUpAppointment')}
          value={followUpStatus}
          isLoading={infoLoading}
        />
      </Flex>
    </div>
  );
};
export default PatientInfo;
